import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import ReactSelect from "react-select";
import { apiRequest } from "../../utils/utils";

const ManageMuviOwnerShip = (props) => {
  const { data } = props;
  const [state, setState] = useState({
    accountManager: [],
    salesManager: [],
    tseOwner: [],
    managerData: {},
    ownershipdata: {},
  });

  useEffect(() => {
    setState((state) => {
      return {
        ...state,
        ownershipdata: { ...data },
      };
    });
  }, [data]);

  useEffect(() => {
    setState((state) => {
      return {
        ...state,
        managerData: {
          ...state.managerData,
          sales_manager: state.ownershipdata.sales_manager
            ? state.ownershipdata.sales_manager
            : "",
          account_manager: state.ownershipdata.account_manager
            ? state.ownershipdata.account_manager
            : "",
          tse_owner: state.ownershipdata.tse_owner
            ? state.ownershipdata.tse_owner
            : "",
        },
      };
    });
  }, [state.ownershipdata]);

  useEffect(() => {
    setState((state) => {
      return {
        ...state,
        accountManager: (props.accountManager || []).map((it) => ({
          label: it.name,
          value: it.user_uuid,
        })),
        salesManager: (props.salesManager || []).map((it) => ({
          label: it.name,
          value: it.user_uuid,
        })),
        tseOwner: (props.tseOwner || []).map((it) => ({
          label: it.name,
          value: it.user_uuid,
        })),
      };
    });
  }, [props.salesManager, props.accountManager, props.tseOwner]);

  const accountManagerHandler = (evt) => {
    setState((state) => {
      return {
        ...state,
        managerData: {
          ...state.managerData,
          account_manager: evt ? evt.value : "",
        },
      };
    });
  };
  const salesManagerHandler = (evt) => {
    setState((state) => {
      return {
        ...state,
        managerData: {
          ...state.managerData,
          sales_manager: evt ? evt.value : "",
        },
      };
    });
  };
  const tseOwnerHandler = (evt) => {
    setState((state) => {
      return {
        ...state,
        managerData: {
          ...state.managerData,
          tse_owner: evt ? evt.value : "",
        },
      };
    });
  };

  const loginSubmit = async () => {
    
    const postData = {
      product_key: data && data.product_key,
      customer_id: data && data.customer_id,
      ...state.managerData,
      is_live: data && data.isLive,
    };

    let crmStagingUrl =
      process.env.REACT_APP_CRM + "/muvi6/manage-muvi-ownership";

      const response = await apiRequest(crmStagingUrl,"POST", postData);
      if(response.code ===200) {
        props.syncFilterWithAggrid();
        props.close()
      }

  };
  return (
    <Modal show={props.show} onHide={props.close}>
      <Modal.Header closeButton>
        <Modal.Title>{props.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form>
          <div className="alert alert-info">
            Note: Assigning an account manager will mark this customer as Key
            Account, to Unmark it please open customer details page and Unmark
            it.
          </div>
          <div className="form-group">
            <label>Account Manager</label>
            <div>
              <ReactSelect
                options={state.accountManager}
                value={(state.accountManager || []).find(
                  (item) => item.value === state.managerData.account_manager
                ) || ""}
                isClearable
                onChange={accountManagerHandler}
                block
              />
            </div>
          </div>
          <div className="form-group">
            <label>Sales Manager</label>
            <div>
              <ReactSelect
                isClearable
                value={(state.salesManager || []).find(
                  (item) => item.value === state.managerData.sales_manager
                ) || ""}
                options={state.salesManager}
                onChange={salesManagerHandler}
              />
            </div>
          </div>
          <div className="form-group">
            <label>Tse Owner</label>
            <div>
              <ReactSelect
                isClearable
                value={(state.tseOwner || []).find(
                  (item) => item.value === state.managerData.tse_owner
                )||""}
                options={state.tseOwner}
                onChange={tseOwnerHandler}
              />
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              type="button"
              variant="dark"
              className="btn-dark-btn"
              onClick={props.close}
            >
              Close
            </Button>
            <Button
              type="button"
              variant="primary"
              onClick={() => loginSubmit()}
            >
              Submit
            </Button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default ManageMuviOwnerShip;



// WEBPACK FOOTER //
// ./src/components/childcomponents/ManageMuviOwnerShip.js